import { httpClient, unwrap } from './httpClient';

export async function listSubscriptions({ search, userIds, serviceCallback, status, isFreemium, sortBy, sortDir, page, pageSize }) {
  const response = await httpClient.get('/admin/subscriptions/', {
    params: {
      search: search || undefined,
      user_ids: userIds?.length ? userIds.join(',') : undefined,
      service_callback: serviceCallback || undefined,
      status: status ?? undefined,
      is_freemium: isFreemium ?? undefined,
      sort_by: sortBy,
      sort_dir: sortDir,
      page,
      page_size: pageSize,
    },
  });
  return unwrap(response);
}

export async function createSubscription(payload) {
  const response = await httpClient.post('/admin/subscriptions/', payload);
  return unwrap(response);
}

export async function updateSubscription(id, payload) {
  const response = await httpClient.post(`/admin/subscriptions/${id}`, payload);
  return unwrap(response);
}

export async function deleteSubscription(id) {
  const response = await httpClient.delete(`/admin/subscriptions/${id}`);
  return unwrap(response);
}

const adminSubscriptionService = {
  listSubscriptions,
  createSubscription,
  updateSubscription,
  deleteSubscription,
};

export default adminSubscriptionService;
